document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('.hero__media-grid');
  if (!grid) return;

  // Seleccionar todos los wrappers directos del grid
  const wrappers = Array.from(grid.children).filter(el =>
    el.classList.contains('hero__media-wrapper')
  );

  if (wrappers.length < 2) return;

  // Marcar el grid y los slides
  grid.setAttribute('data-slideshow', 'true');
  wrappers.forEach(el => el.classList.add('hero-slide-item'));

  let current = 0;
  wrappers[current].classList.add('is-active');

  setInterval(() => {
    wrappers[current].classList.remove('is-active');
    current = (current + 1) % wrappers.length;
    wrappers[current].classList.add('is-active');
  }, 4000);
});

